import React, { useEffect, useState } from "react";
import Input from "../../components/textfield/input";
import "../../assets/styles/admin/quotation.scss";
import moment from "moment";
import QuotationCreateStep1 from "./quotationCreateStep1";
import QuotationCreateStep2 from "./quotationCreateStep2";
const CreateQUO = () => {
  const [step, setStep] = useState(1);
  const [selectItem, setSelectItem] = useState<any>([]);
  const [other, setOther] = useState<any>([]);
  const [userData, setUserData] = useState<object>({
    customer: "",
    purchaseType: "normal",
    categories: [],
    sale: "",
    date: moment()
  });
  return (
    <div>
      {
        (step === 1) ?
          <QuotationCreateStep1
            Item={selectItem}
            userData={userData}
            ChangItem={(item: any) => setSelectItem(item)}
            ChangStep={(number: number) => setStep(number)}
            ChangOther={(text: string) => setOther(text)}
            ChangUserData={(data: object) => setUserData(data)} />
          :
          <QuotationCreateStep2 Item={selectItem} userData={userData} ChangItem={(item: any) => setSelectItem(item)} ChangStep={(number: number) => setStep(number)} other={other} />
      }
    </div>
  );
};
export default CreateQUO;
